'use client'

import Feed from '@/components/events/Feed/Index'
import EventTab from '@/components/events/Tab'
import { useSearchParams } from 'next/navigation'

import useSWR from 'swr'

import { EdsnSpinner } from '@8percent/edsn-react'

import styles from './style.module.css'

const fetcher = (...args: Parameters<typeof fetch>) => fetch(...args).then(res => res.json())

export type ImageObject = {
  url: string
  width: number
  height: number
}

type Feed = {
  id: string
  eventId: number
  title: string
  thumbnail: ImageObject
  link: string
  startDate: `${number}-${number}-${number}T${number}:${number}:${number}Z`
  endDate: `${number}-${number}-${number}T${number}:${number}:${number}Z`
  state: string | undefined
  createdAt: `${number}-${number}-${number}T${number}:${number}:${number}Z`
  contentType: string
  isAlways: boolean
  customEntry?: string
  redirectLink?: string
}

export default function FeedMainGroup() {
  const searchParams = useSearchParams()

  const state = searchParams?.get('state') as string

  const { data: ingContent = [], isLoading: isLoadingIngContent } = useSWR<Feed[]>(
    'https://contents-api.8percent.kr/api/cms/common/events/list/ing',
    fetcher
  )
  const { data: finishContent = [], isLoading: isLoadingFinishContent } = useSWR<Feed[]>(
    'https://contents-api.8percent.kr/api/cms/common/events/list/finish',
    fetcher
  )
  const { data: winnerContent = [], isLoading: isLoadingWinnerContent } = useSWR(
    'https://contents-api.8percent.kr/api/cms/common/events/list/winner',
    fetcher
  )

  const getContentByState = (
    state: string | undefined | null,
    ingContent: Feed[],
    finishContent: Feed[],
    winnerContent: Feed[]
  ) => {
    if (state === 'ing') {
      return ingContent
    }

    if (state === 'finish') {
      return finishContent
    }

    if (state === 'winner') {
      return winnerContent
    }

    return ingContent
  }

  const isLoading = isLoadingIngContent || isLoadingFinishContent || isLoadingWinnerContent

  const feeds = getContentByState(state, ingContent, finishContent, winnerContent)

  const isWinnerContent = !!winnerContent.length

  return (
    <div>
      <div className={styles.eventTab}>
        <EventTab isWinnerContent={isWinnerContent}></EventTab>
      </div>

      {isLoading ? (
        <div className={styles.loading}>
          <EdsnSpinner size="l" />
        </div>
      ) : (
        <div className={styles.events}>
          {feeds?.map(feed => {
            return (
              <Feed
                eventId={feed.eventId}
                key={feed.eventId}
                id={feed.id}
                title={feed.title}
                thumbnail={feed.thumbnail}
                startDate={feed.startDate}
                endDate={feed.endDate}
                state={state}
                isAlways={feed.isAlways}
                redirectLink={feed.redirectLink}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}
